/*
Sohel 11/16/2022 2700912712 Implemented Add Rule Screen
Sohel 11/16/2022 2700912712 Save API Payload Changes.
Sohel 11/17/2022 2700912712 Added Override Functionality
Sohel 12/01/202 2700912712 rules changes
Sohel 12/01/2022 2700912712 Added Override Type in payload.
Sai Maheshwar 12/02/2022 2700912712 mapped new repository fields data.
Sai Maheshwar 12/03/2022 2700912712 fixed AND/OR condition issue
Sai Maheshwar 12/03/2022 2700912712fixed resultExpression payload issue
lalitha 12/03/2022 2700912712 Radio button color changed
Sai maheshwar 12/04/2022 2700912712  added unsaved changes alert
lalitha 12/08/2022 2700912712 Renamed to Button Add Filter Rules
Sohel 12/14/2022 2700912712 Test Functionality Payload Changes
Ashraf 12/14/2022 2700912712 removed role access
akhila 12/15/2022 2700912712 changed dropdown values
lalitha 15/12/2022 2700912712 added access role in filter rule group
Ashraf 15/12/2022 2700912712 fixed role access
akhila 12/16/2022 2700912712 added filter condition in payload
akhila 12/20/2022 2700912712 changed overRide title and fixed toaster
akhila 12/23/2022 2700912712 changed test popup title
sai Krishna 12/23/2022 2700912712 add  filtercode  and filter description
akhila 12/26/2022 2700912712 fixed delete popup
Sai Maheshwar 12/12/2022 2700912712 fixed AND OR issue
akhila 12/27/2022 2700912712 changed label for button
sai Krishna 12/27/2022 2700912712 add  filtercode  and filter description
Ashraf 01/02/2023 2700912712 renamed usage header title
kavyareddy 01/06/2023 2700912712 Disabled test button when result expression is empty
Akhila 01/25/2023 2700912712 Added Save button
Ravi 02/21/2023 2700912712 Display field Data Above the Add Filter Rule Button
Raghu 02/21/2023 2700912712 changed buttons color
Raghu 03/01/2023 2700912712 fixed alignments
Sohel 03/08/2023 2700912712 Added All True Functionality
Sohel 03/08/2023 2700912712 Save button conditions
suresh peddavoora 04/06/2023 2700912712 radio buttons color fixes
Sohel 04/13/2023 2698964415 Added Type Field in Filter Criteria
Sohel 04/13/2023 2698964415 Added Field Type Issue
Prakash 24/04/2023 2698964415 Fixed spaceing issue
Akhila 05/02/2023 2698811066 added rhsField,rhsRepository in payload in sql rules
Prakash 16/05/2023 2698964415 Fixed alignments issue in tab view
Ravi 05/31/2023 2700912712 changed delete popup message
Sohel 06/20/2023 2700912712 Enabled Save Button
Akhila 06/21/2023 2700912712 conditionally disable save and finish button on submission
Ashraf 08/08/2023 2700912712 Added rhs fields missing in test payload
Sohel 10/05/2023 2698811066 Filter Criteria  Added Table Column Name and Field Name Changes
Sohel 10/13/2023 2698811066 Filter Criteria Changed SQL Output
Sohel 10/13/2023 2698811066 Filter Condition Changes
Sohel 10/16/2023 2698811066 SQl Output value Changes
Sohel 10/17/2023 2698811066 Fixed Role Access Disabled Issue
Sohel 10/19/2023 2698811066 Added Value Field Validation
Sohel 11/29/2023 2698811066 type field validation and payload bug fix
*/
import {
  Button,
  TextField,
  FormHelperText,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import DialogBox from '../../../../components/DialogBox';

// import { Controller, useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import {
  testFilterResetData,
  fetchFilterAllCodeAndDisplayName,
  resetFormula,
  postFormulaSelectFields,
} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {getBaseCategory, resetData} from '../../../../redux/reducers/GlobalField/AddFieldList';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import OverrideRule from '../../../../components/OverrideRule';
import AddIcon from '@material-ui/icons/Add';
import TestComponent from '../FilterRuleGroup/AddFilterRuleGroup/TestComponent';
import {
  postFilterRuleGroup,
  resetMessage,
  fetchFilterRuleGroup,
  ResetAddRule as resetAddRule,
} from '../../../../redux/reducers/BRE/FilterRuleGroup';
import {Field, FieldArray, Form, Formik} from 'formik';
import SqlRuleBuilder from '../../../../components/SqlRuleBuilder/FilterRules';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import BreadCrums from '../../../../util/BreadCrum';
import {getOptions} from '../../../../components/SqlRuleBuilder/utils';
import {
  submissionEnd,
  submissionStart,
} from '../../../../redux/reducers/CommonActions/commonActions';
const typeOptions = [
  {label: 'Field', value: 'file'},
  {label: 'Value', value: 'value'},
];
const RuleGroup1 = ({
  setValue,
  handleBack,
  handleDirty,
  rowSelected,
}) => {
  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
  }, []);
  const {roleData} = useSelector(({role}) => role);
  const filterRuleRoleAccess = roleData?.window?.['Filter Rules']?.['FR'];
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const hideValuesConditions = [
    'Is',
    'Is not',
    'Less than',
    'Greater than',
    'Less than equal',
    'Greater than equal',
  ];
  const resultRef = useRef();
  const saveRef = useRef(false);
  const formRef = useRef();
  const {
    loading,
    successMsg,
    errorMsg,
    filterRuleGroupData,
    addFilterRuleGroupStatus,
    filterRuleGroupId,
    addRuleData,
    userMetrix,
    addRuleStatus,
  } = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  const {formulaFieldsData} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const initialVal = {
    sqlExpression: '',
    formulaExpression: '',
    resultExpCondition: '',
    sqlRules: [],
  };
  // let initialVal = {
  //   sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : "",
  //   formulaExpression: filterRuleGroupData?.formulaExpression
  //     ? filterRuleGroupData?.formulaExpression
  //     : "",
  //   resultExpCondition:
  //     filterRuleGroupData?.defaultOperator == null ? "AND" : filterRuleGroupData?.defaultOperator,
  // };
  // const {
  //   addRuleData,
  //   userMetrix,
  //   isLoading,
  //   addRuleGroupStatus,
  //   addRuleStatus,
  //   testFilterResponse,
  //   allFilterCodeAndDisplayName,
  // } = useSelector(({ addRuleGroup }) => addRuleGroup);

  const {systemerrorMsg, systemsuccessMsg} = useSelector(({systemNotes}) => systemNotes);
  const [deletedRules, setDeletedRules] = useState([]);
  const [dialogState, setDialogState] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const currentDeleteIndex = useRef(null);
  const [validate, setValidate] = useState(false);

  const [overRiding, setOverRiding] = useState({});
  const [openTestForm, setOpenTestForm] = useState(false);
  // const [testRows, setTestRows] = useState([]);
  // const [testColumns, setTestColumns] = useState([]);
  const [initialValues, setInitialValues] = useState(initialVal);
  const arrayHelperRef = useRef();
  const formattedFieldList =
    formulaFieldsData?.length > 0 &&
    formulaFieldsData.map((field) => ({
      globalField: (field?.repositoryName + '.' + field?.fieldName),
      fieldType: field.dataType,
      repository: field?.repositoryName,
      fieldName: field?.fieldName,
    }));
  const handleValidationClose = () => {
    setValidate(false);
    dispatch(submissionEnd());
  };

  // const getCategoryValue = () => {
  //   if (StepperFilter && fieldListCode) {
  //     return getCategoryObject(fieldListData.baseCategory, baseCategoryData);
  //   } else {
  //     return filterRuleGroupData?.category
  //       ? getCategoryObject(filterRuleGroupData?.category, baseCategoryData)
  //       : "";
  //   }
  // };

  useEffect(() => {
    dispatch(fetchFilterAllCodeAndDisplayName());
  }, []);

  useEffect(() => {
    if(filterRuleGroupData?.id){
      dispatch(
        postFormulaSelectFields({
          groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
          ruleType: 'Filters',
          filterFormulaRuleGroupId:filterRuleGroupData?.id ? filterRuleGroupData?.id : 0 ,
        }),
      );
    }
  
  }, [filterRuleGroupData?.id]);

  // useEffect(() => {
  //   if (StepperFilter && fieldListCode) {
  //     dispatch(fetchFieldListData(fieldListCode));
  //     setSelectedFieldList(fieldListCode);
  //   }
  // }, [fieldListCode]);

  const validationSchema = Yup.object().shape({
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed().when('condition', {
          is: (val) => {
            return !['isNotBlank', 'isBlank'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        type: Yup.mixed().test('type', 'Type is required', (value, ctx) => {
          if (!value?.value && hideValuesConditions?.includes(ctx.parent?.condition?.label)) {
            return false;
          } else {
            return true;
          }
        }),
      }),
    ),
    sqlExpression: Yup.string().test('sqlExpression', 'Result Expression is required', (value) => {
      if (!value && formRef.current?.values?.sqlRules?.length > 0) {
        return false;
      } else {
        return true;
      }
    }),
  });

  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
      }, 2500);
    }
  }, [userMetrix, addRuleStatus]);

  useEffect(() => {
    if (filterRuleGroupId) {
      dispatch(fetchFilterRuleGroup(filterRuleGroupId));
    }
  }, [filterRuleGroupId]);
  useEffect(() => {
    if (Object.keys(filterRuleGroupData).length > 0) {
      const newInitialVal = {
        sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : '',
        formulaExpression: filterRuleGroupData?.formulaExpression ?
          filterRuleGroupData?.formulaExpression :
          '',
        resultExpCondition:
          filterRuleGroupData?.defaultOperator == null ?
            'AND' :
            filterRuleGroupData?.defaultOperator,
      };

      const sqlRules =
        filterRuleGroupData.filterSQLRuleResponse &&
        filterRuleGroupData.filterSQLRuleResponse.map((data) => {
          const selectedFieldList =
            formulaFieldsData &&
            formulaFieldsData.filter(
              (el) => el.fieldName + el.repositoryName === data.field + data.repository,
            )[0];
          const selectedCondition =
            selectedFieldList &&
            getOptions(selectedFieldList.dataType?.toLowerCase()).filter(
              (el) => el.value === data.filterCondition,
            )[0];
          let field;
          if (selectedFieldList) {
            const globalField = (
              selectedFieldList?.repositoryName +
              '.' +
              selectedFieldList?.fieldName
            );
            const {
              dataType: fieldType,
              fieldName: fieldName,
              repositoryName: repository,
              // dbColumnName:globalField,
            } = selectedFieldList;
            field = {fieldType, globalField, repository, fieldName};
          }
          const obj = {
            field: field ? field : null,
            condition: selectedCondition,
            value:
              data?.type === 'file' ?
                formulaFieldsData?.filter((el) => el.fieldName === data.value)?.[0] :
                data.value || '',
            sqlValue: data.sqlExpression,
            value1: data.value1,
            ruleCode: data.ruleCode,
            id: data.id,
            createdBy: data.createdBy,
            groupCode: data.groupCode,
            type: data.type ? typeOptions?.filter((el) => el.value === data?.type)?.[0] : '',
          };
          return obj;
        });
      sqlRules.sort((a, b) => {
        if (a.ruleCode < b.ruleCode) {
          return -1;
        }
        if (a.ruleCode > b.ruleCode) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      setInitialValues((prev) => ({...prev, ...newInitialVal, sqlRules: sqlRules}));

      // setRules(sqlRules);
    }
  }, [formulaFieldsData, filterRuleGroupData]);

  useEffect(() => {
    if (addFilterRuleGroupStatus === 200 && !errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        filterRuleGroupId && dispatch(fetchFilterRuleGroup(filterRuleGroupId));
        !saveRef.current && setValue(0) && dispatch(resetFormula());
      }, 1500);
    }
  }, [addFilterRuleGroupStatus, errorMsg]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        handleValidationClose();
      }, 1500);
    }
  }, [errorMsg, successMsg]);
  const onSubmit = (data) => {
    dispatch(submissionStart());
    if (data?.sqlRules?.length === 0) {
      setValidate(true);
    } else if (data?.sqlRules?.length > 0) {
      const passValues = {
        sqlRules: data.sqlRules?.map((item, i) => {
          return {
            groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code.toUpperCase() : '',
            id: item?.id ? item?.id : 0,
            ruleCode: item?.ruleCode,
            field: item?.field?.fieldName,
            repository: item.field.repository,
            filterCondition: item?.condition?.value,
            sqlExpression: item?.sqlValue,
            value1: item?.value1,
            value: item?.type?.value === 'file' ? item?.value?.fieldName : item?.value,
            type:
              hideValuesConditions?.includes(item?.condition?.label) && item?.type?.value
                ? item?.type?.value
                : '',
            rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
            rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
            filterRuleGroupId:filterRuleGroupData?.id
          };
        }),
        defaultOperator: data.resultExpCondition,
        id: filterRuleGroupData ? filterRuleGroupData?.id : 0,
        sqlDeletedId: deletedRules,
        override: 'No',
        code: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
        description: filterRuleGroupData?.description ? filterRuleGroupData?.description : '',
        displayName: filterRuleGroupData?.displayName ? filterRuleGroupData?.displayName : '',
        sqlExpression: data?.sqlExpression ? data?.sqlExpression : '',
        category: '',
        fieldListCode: filterRuleGroupData?.fieldListCode ? filterRuleGroupData?.fieldListCode : '',
        oldFilterRuleGroupCode: '',
        isDraft: 'N',
        overrideType: 'FILTER',
      };
      setOverRiding(passValues);
      dispatch(postFilterRuleGroup(passValues));
    }
  };

  const handleTestFormClose = () => {
    dispatch(testFilterResetData());
    setOpenTestForm(false);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleDialogState = () => {
    setDialogState(false);
  };
  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: {values, setFieldValue},
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];

    const copyDeleteArr = [...deletedRules];
    if ('filterSQLRuleResponse' in filterRuleGroupData) {
      copyDeleteArr.push(filterRuleGroupData?.filterSQLRuleResponse[i]?.id);
    }
    copyArr.splice(i, 1);
    setDeletedRules(copyDeleteArr.filter(Boolean));
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
  };
  const handleTest = (values) => {
    const passValuesTest = {
      fieldListCode: filterRuleGroupData?.fieldListCode,
      result: values.sqlExpression,
      sqlRules: values.sqlRules?.map((item) => {
        return {
          groupCode: filterRuleGroupData?.code ?
            filterRuleGroupData?.code.toUpperCase() :'',
          ruleCode: item.ruleCode,
          sqlCode: item.sqlValue,
          id: item?.id || 0,
          field: item?.field?.fieldName,
          repository: item?.field?.repository,
          filterCondition: item?.condition?.value,
          rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
          rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
        };
      }),
    };
    return passValuesTest;
  };
  const handleSubmit = () => {
    const data = formRef.current?.values;
    if (data) {
      const passValues = {
        sqlRules: data.sqlRules?.map((item, i) => {
          return {
            groupCode: filterRuleGroupData?.code ? filterRuleGroupData?.code.toUpperCase() : '',
            id: item?.id ? item?.id : 0,
            ruleCode: item?.ruleCode,
            field: item?.field?.fieldName,
            repository: item.field.repository,
            filterCondition: item?.condition?.value,
            sqlExpression: item?.sqlValue,
            value1: item?.value1,
            value: item?.type?.value === 'file' ? item?.value?.fieldName : item?.value,
            type:
              hideValuesConditions?.includes(item?.condition?.label) && item?.type?.value
                ? item?.type?.value
                : '',
            rhsField: item?.type?.value === 'file' ? item?.value?.fieldName : '',
            rhsRepository: item?.type?.value === 'file' ? item?.value?.repositoryName : '',
            filterRuleGroupId:filterRuleGroupData?.id 
          };
        }),
        defaultOperator: data.resultExpCondition,
        id: filterRuleGroupData ? filterRuleGroupData?.id : 0,
        sqlDeletedId: deletedRules,
        override: 'No',
        code: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
        description: filterRuleGroupData?.description ? filterRuleGroupData?.description : '',
        displayName: filterRuleGroupData?.displayName ? filterRuleGroupData?.displayName : '',
        sqlExpression: data?.sqlExpression ? data?.sqlExpression : '',
        category: '',
        fieldListCode: filterRuleGroupData?.fieldListCode ? filterRuleGroupData?.fieldListCode : '',
        oldFilterRuleGroupCode: '',
        isDraft: 'N',
        overrideType: 'FILTER',
      };
      setOverRiding(passValues);
      dispatch(postFilterRuleGroup(passValues));
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue: setValueRuleGroup,
            errors,
            handleChange,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <div>
                <BreadCrums
                  name={'Filter Name'}
                  code={filterRuleGroupData?.code}
                  description={'Filter Description'}
                  descriptionValue={filterRuleGroupData?.description}
                />
              </div>
              <Form noValidate>
                <FieldArray
                  name="sqlRules"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        {values.sqlRules.map((rule, index) => (
                          <>
                            <Field
                              key={index}
                              name={`sqlRules[${index}]`}
                              component={SqlRuleBuilder}
                              index={index}
                              fields={formattedFieldList}
                              handleDelete={() => {
                                setIsDelete(true);
                                currentDeleteIndex.current = index;
                                arrayHelperRef.current = arrayHelpers;
                              }}
                              mapFieldsData={
                                Array.isArray(formulaFieldsData) ? formulaFieldsData : []
                              }
                              isFilterRules={true}
                            />
                            {/* <ErrorMessage name="rules" /> */}
                          </>
                        ))}
                        <div className="new-standard-textfields table-header mt-3">
                          {/* <Typography variant="h4"></Typography> */}
                          <RadioGroup
                            aria-label="resultExpCondition"
                            name="resultExpCondition"
                            value={values.resultExpCondition}
                            onChange={(e) => {
                              handleChange(e);
                              const result = values.sqlRules.map((el, i) => el.ruleCode);
                              resultRef.current = false;
                              setValueRuleGroup(
                                'sqlExpression',
                                result.join(` ${e.target.value} `),
                              );
                            }}
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              flexDirection: 'row',
                            }}
                          >
                            <FormControlLabel
                              value="AND"
                              control={<Radio disabled={values.resultExpCondition == ''} />}
                              label="AND"
                            />
                            <FormControlLabel
                              value="OR"
                              control={<Radio />}
                              label="OR"
                              disabled={values.resultExpCondition == ''}
                            />
                          </RadioGroup>

                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot} `}
                            disabled={!filterRuleRoleAccess?.add}
                            onClick={() => {
                              const newRuleCount =
                                values.sqlRules.length > 0 &&
                                Number(
                                  values.sqlRules[values.sqlRules.length - 1].ruleCode.slice(1),
                                ) + 1;
                              const newRuleCode =
                                values.sqlRules.length > 0 ? 'S' + newRuleCount : 'S1';
                              arrayHelpers.push({
                                ruleCode: newRuleCode,
                                field: '',
                                condition: '',
                                value: '',
                                value1: '',
                                sqlValue: '',
                              });
                              if (!resultRef.current && values['resultExpCondition']) {
                                const result = values.sqlRules.map((el, i) => el.ruleCode);
                                result.push(newRuleCode);
                                setValueRuleGroup(
                                  'sqlExpression',
                                  result.join(` ${values['resultExpCondition']} `),
                                );
                              }
                            }}
                          >
                            <AddIcon />
                            Add Filter Rule
                          </Button>
                        </div>
                      </>
                    );
                  }}
                />
                {/* <div className="table-header">
          <Typography variant="h4"></Typography>

          <Button
            variant="outlined"
            className={`search-btn mx-1 ${classes.buttonRoot}`}
            disabled={!filterRuleRoleAccess?.add}
            onClick={() => {
              handleAddRule();
            }}
          >
            <AddIcon />
            Add Filter Rule
          </Button>
        </div>
        <RuleBuilder
          rules={rules}
          setRules={setRules}
          deletedRules={deletedRules}
          setDeletedRules={setDeletedRules}
          fields={formattedFieldList}
          handleExpression={handleExpression}
        /> */}

                <div className="d-flex justify-content-space-between align-items-center mt-1 new-standard-textfields">
                  <div className="col-md-6 col-lg-4 col-xl-4 pl-0 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Result Expression"
                      margin="dense"
                      name="sqlExpression"
                      variant="outlined"
                      label="Result Expression"
                      value={values.sqlExpression}
                      disabled={values.sqlRules.length === 0}
                      required={values.sqlRules.length > 0}
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setValueRuleGroup('resultExpCondition', '');
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      error={values.sqlRules.length > 0 ? Boolean(errors.sqlExpression) : ''}
                    />
                    <FormHelperText variant="outlined">
                      {values.sqlRules.length > 0 && errors.sqlExpression ?
                        errors.sqlExpression :
                        ''}
                    </FormHelperText>
                  </div>
                  <Button
                    variant="outlined"
                    className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                    // disabled={!values?.sqlExpression}
                    onClick={() => {
                      setOpenTestForm(true);
                    }}
                  >
                    Test
                  </Button>
                </div>
                <div className="new-standard-textfields d-flex justify-content-center mb-2">
                  <Button
                    type="button"
                    onClick={() => {
                      // reset(initialValues);
                      // if (!Object.keys(filterRuleGroupData)?.length) {
                      //   setFormDataFormula([]);
                      //   setFormData([]);
                      // } else {
                      //   setReset(!tableDataReset);
                      // }
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {filterRuleGroupData?.isDraft === "N" && ( */}
                  <span>
                    <Button
                      variant="outlined"
                      // disabled={
                      //   values.sqlRules.length === 0 ||
                      //   (!filterRuleRoleAccess?.edit &&
                      //     filterRuleGroupData?.filterSQLRuleResponse?.length > 0)
                      // }
                      disabled={(!filterRuleRoleAccess?.edit && filterRuleGroupData?.code && rowSelected) || enabledSubmission}
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        saveRef.current = true;
                        // if (
                        //   values.sqlRules.length === 0 &&
                        //   filterRuleGroupData?.filterSQLRuleResponse?.length === 0
                        // ) {
                        //   setValidate(true);
                        // } else {
                        //   saveRef.current = true;
                        if (formRef.current.isValid) {
                          onSubmit(values);
                        }
                        handleDirty(false, 'fixed');
                      }}
                    >
                      Save
                    </Button>
                  </span>
                  {/* )} */}

                  <Button
                    onClick={() => {
                      saveRef.current = false;
                      if (formRef.current.isValid) {
                        onSubmit(values);
                      }
                    }}
                    variant="outlined"
                    className={`mx-1 search-btn ${classes.buttonRoot}`}
                    disabled={
                      (!filterRuleRoleAccess?.edit && filterRuleGroupData?.code && rowSelected) ||
                      enabledSubmission
                    }
                  >
                    Finish
                  </Button>
                </div>
                {/* <DialogBox
          open={open || isEditMode}
          dialogClose={handleClose}
          hideFooter={true}
          title={(isEditMode && "Edit Rule ") || (open && "Add Rule")}
          maxWidth={"md"}
        >
          <AddRuleForm
            rowData={rowData}
            setFormData={setFormData}
            formData={formData}
            setOpen={setOpen}
            handleClose={handleClose}
            isEditMode={isEditMode}
            oldRuleCode={oldRuleCode}
            setIsEditMode={setIsEditMode}
            fieldCode={fieldCode}
            sqlSNo={sqlSNo}
          />
        </DialogBox> */}
                {/* <DialogBox
          open={openFormula || isEditModeFormula}
          dialogClose={handleClose}
          hideFooter={true}
          title={(isEditModeFormula && "Edit Rule ") || (openFormula && "Add Rule")}
          maxWidth={"md"}
        >
          <AddRuleFormFormula
            rowData={rowDataFormula}
            setFormData={setFormDataFormula}
            formData={formDataFormula}
            setOpen={setOpenFormula}
            handleClose={handleClose}
            isEditMode={isEditModeFormula}
            oldRuleCode={oldRuleCodeFormula}
            setIsEditMode={setIsEditModeFormula}
            fieldCode={fieldCode}
            formulaSNo={formulaSNo}
          />
        </DialogBox> */}

                <OverrideRule
                  dialogTitle="Override Rule"
                  dialogOpen={dialogState}
                  dialogClose={handleDialogState}
                  title={`This Filter Rule has been used in the following places.`}
                  handleOverrideClose={handleDialogState}
                  handleOverrideSubmit={() => {
                    dispatch(postFilterRuleGroup({...overRiding, override: 'Yes'}));
                    handleDialogState();
                  }}
                  data={addRuleData}
                />

                <DialogBox
                  open={openTestForm}
                  dialogClose={handleTestFormClose}
                  title={
                    <>
                      <span>
                        <b>{'Run Test For'} :</b>
                      </span>
                      <span className="result-expression">{values?.sqlExpression} </span>
                    </>
                  }
                  maxWidth="lg"
                >
                  <TestComponent passValuesTest={handleTest(values)} />
                </DialogBox>

                <DeleteTableRecordPopup
                  open={isDelete}
                  dialogClose={handleDeleteClose}
                  title="Delete Filter Rule"
                  value={`Are you sure you want to delete the ${
                    values?.sqlRules[currentDeleteIndex.current]?.ruleCode
                  }  Filter Rule?`}
                  handleSubmit={handleDeleteRule}
                />
              </Form>
              <DeleteTableRecordPopup
                open={validate}
                dialogClose={handleValidationClose}
                title="Warning !"
                value={`Filter Rule hasn't been added, Would you like to Skip and Continue?`}
                handleSubmit={handleSubmit}
              />
            </>
          );
        }}
      </Formik>
      {loading && <PageLoader />}
      {(errorMsg || systemerrorMsg) && <ErrorSnackbar errorMsg={errorMsg || systemerrorMsg} />}
      {(successMsg || systemsuccessMsg) && (
        <SuccessSnackbar
          successMsg={`Filter rule(s) added/modified successfully` || systemsuccessMsg}
        />
      )}
    </>
  );
};

export default RuleGroup1;
